module.exports = __webpack_public_path__ + "static/media/BringThemHomeNowLogo.b7f07019.svg";